import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";

import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import InscricaoPage from "@/pages/InscricaoPage";
import SucessoPage from "@/pages/SucessoPage";
import ConsultaPage from "@/pages/ConsultaPage";
import AreaCidadaoPage from "@/pages/AreaCidadaoPage";
import DashboardPage from "@/pages/DashboardPage";
import InscricoesPage from "@/pages/InscricoesPage";
import DetalheInscricaoPage from "@/pages/DetalheInscricaoPage";
import UsuariosPage from "@/pages/UsuariosPage";
import RelatoriosPage from "@/pages/RelatoriosPage";
import VulnerabilidadesPage from "@/pages/VulnerabilidadesPage";
import CitizenUpdatePage from "@/pages/CitizenUpdatePage";
import ConfigAtualizacaoPage from "@/pages/ConfigAtualizacaoPage";
import EditarInscricaoPage from "@/pages/EditarInscricaoPage";
import EmpreendimentosPage from "@/pages/EmpreendimentosPage";
import InformacoesPage from "@/pages/InformacoesPage";
import BancoDeDadosPage from "@/pages/BancoDeDadosPage";
import DocumentosObrigatoriosPage from "@/pages/DocumentosObrigatoriosPage";
import AuditoriaPage from "@/pages/AuditoriaPage";
import VerificarPage from "@/pages/VerificarPage";
import PeriodoInscricoesPage from "@/pages/PeriodoInscricoesPage";
import BackupBrowserPage from "@/pages/BackupBrowserPage";
import MapaBairrosPage from "@/pages/MapaBairrosPage";
import DossiePage from "@/pages/DossiePage";
import CompararDossiesPage from "@/pages/CompararDossiesPage";
import AlertasEmailPage from "@/pages/AlertasEmailPage";
import PontosApoioPage from "@/pages/PontosApoioPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import VincularCpfPage from "@/pages/VincularCpfPage";

const ROLES_CIDADAO = ["cidadao"];
const ROLES_ADMIN = ["super_admin"];
const ROLES_PAINEL = ["super_admin", "funcionario"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/inscricao" element={<InscricaoPage />} />
            <Route path="/sucesso/:protocolo" element={<SucessoPage />} />
            <Route path="/consultar" element={<ConsultaPage />} />
            <Route path="/atualizar" element={<CitizenUpdatePage />} />
            <Route path="/verificar" element={<VerificarPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="/vincular-cpf" element={
              <ProtectedRoute roles={ROLES_CIDADAO}><VincularCpfPage /></ProtectedRoute>
            } />

            <Route path="/area-cidadao" element={
              <ProtectedRoute roles={ROLES_CIDADAO}><AreaCidadaoPage /></ProtectedRoute>
            } />

            <Route path="/admin" element={
              <ProtectedRoute roles={ROLES_PAINEL}><AdminLayout /></ProtectedRoute>
            }>
              <Route index element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="dashboard"><DashboardPage /></ProtectedRoute>
              } />
              <Route path="inscricoes" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.view"><InscricoesPage /></ProtectedRoute>
              } />
              <Route path="inscricoes/:id" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.view"><DetalheInscricaoPage /></ProtectedRoute>
              } />
              <Route path="inscricoes/:id/editar" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.edit"><EditarInscricaoPage /></ProtectedRoute>
              } />
              <Route path="nova-inscricao" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="nova-inscricao"><InscricaoPage /></ProtectedRoute>
              } />
              <Route path="vulnerabilidades" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="vulnerabilidades"><VulnerabilidadesPage /></ProtectedRoute>
              } />
              <Route path="empreendimentos" element={
                <ProtectedRoute roles={ROLES_ADMIN}><EmpreendimentosPage /></ProtectedRoute>
              } />
              <Route path="informacoes" element={
                <ProtectedRoute roles={ROLES_ADMIN}><InformacoesPage /></ProtectedRoute>
              } />
              <Route path="banco-de-dados" element={
                <ProtectedRoute roles={ROLES_ADMIN}><BancoDeDadosPage /></ProtectedRoute>
              } />
              <Route path="documentos-obrigatorios" element={
                <ProtectedRoute roles={ROLES_ADMIN}><DocumentosObrigatoriosPage /></ProtectedRoute>
              } />
              <Route path="auditoria" element={
                <ProtectedRoute roles={ROLES_ADMIN}><AuditoriaPage /></ProtectedRoute>
              } />
              <Route path="usuarios" element={
                <ProtectedRoute roles={ROLES_ADMIN}><UsuariosPage /></ProtectedRoute>
              } />
              <Route path="config-atualizacao" element={
                <ProtectedRoute roles={ROLES_ADMIN}><ConfigAtualizacaoPage /></ProtectedRoute>
              } />
              <Route path="periodo-inscricoes" element={
                <ProtectedRoute roles={ROLES_ADMIN}><PeriodoInscricoesPage /></ProtectedRoute>
              } />
              <Route path="backup-browser" element={
                <ProtectedRoute roles={ROLES_ADMIN}><BackupBrowserPage /></ProtectedRoute>
              } />
              <Route path="mapa-bairros" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="dashboard"><MapaBairrosPage /></ProtectedRoute>
              } />
              <Route path="dossie" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.view"><DossiePage /></ProtectedRoute>
              } />
              <Route path="dossie/comparar" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.view"><CompararDossiesPage /></ProtectedRoute>
              } />
              <Route path="alertas-email" element={
                <ProtectedRoute roles={ROLES_ADMIN}><AlertasEmailPage /></ProtectedRoute>
              } />
              <Route path="pontos-apoio" element={
                <ProtectedRoute roles={ROLES_ADMIN}><PontosApoioPage /></ProtectedRoute>
              } />
              <Route path="relatorios" element={
                <ProtectedRoute roles={ROLES_PAINEL} perm="inscricoes.exportar"><RelatoriosPage /></ProtectedRoute>
              } />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
